import * as TypeGraphQL from "type-graphql";
export var TradeOutcomeQuality;
(function (TradeOutcomeQuality) {
    TradeOutcomeQuality["EXCELLENT"] = "EXCELLENT";
    TradeOutcomeQuality["GOOD"] = "GOOD";
    TradeOutcomeQuality["FAIR"] = "FAIR";
    TradeOutcomeQuality["POOR"] = "POOR";
    TradeOutcomeQuality["VERY_POOR"] = "VERY_POOR";
})(TradeOutcomeQuality || (TradeOutcomeQuality = {}));
TypeGraphQL.registerEnumType(TradeOutcomeQuality, {
    name: "TradeOutcomeQuality",
    description: undefined,
});
//# sourceMappingURL=TradeOutcomeQuality.js.map